import React from 'react';

export const HOMEPAGE_FAQs = [
  {
    header: 'Who should file an ITR?',
    content: (
      <p>
        An individual whose annual income is more than the basic exemption limit
        of Rs 2.5 lakh should file an ITR. The basic exemption limit for senior
        citizens (60 years onwards and less than 80 years) is Rs 3 lakh, and for
        super senior citizens is Rs 5 lakh.
      </p>
    ),
  },
  {
    header: 'How can I claim deductions for tax saving?',
    content: (
      <p>
        You should file an income tax return to claim tax deductions for tax
        savings such as <a href="https://cleartax.in/s/elss">ELSS</a>, PPF, NSC
        investments and for payments such as housing loan repayments, insurance
        premium and donations.
      </p>
    ),
  },
  {
    header:
      'I receive my salary income after deduction of TDS. Am I required to file an income tax return?',
    content: (
      <p>
        You are required to file an{' '}
        <a href="https://cleartax.in/s/income-tax">income tax</a> return once
        your annual income exceeds Rs 2.5 lakh. A deduction of TDS does not
        replace the requirement to file ITR. While e-filing your ITR, you should
        furnish the details of your annual income, claim deductions and credit
        for TDS deducted by your employer.
      </p>
    ),
  },
  {
    header: 'How do I check TDS details from my form 26AS?',
    content: (
      <p>
        You can check your{' '}
        <a href="https://cleartax.in/s/view-form-26as-tax-credit-statement">
          Form 26AS
        </a>{' '}
        from your e-filing login. ClearTax&apos;s e-filing software
        auto-populates the TDS details from your{' '}
        <a href="https://cleartax.in/s/view-form-26as-tax-credit-statement">
          Form 26AS
        </a>{' '}
        in your income tax return.
      </p>
    ),
  },
  {
    header: 'How can I claim an income tax refund?',
    content: (
      <p>
        You can claim an income tax refund by e-filing your income tax return.
        An e-filing enables you to claim credit for excess TDS paid and a tax
        refund.
      </p>
    ),
  },
  {
    header: 'Is my data filed with ClearTax secure?',
    content: (
      <p>
        ClearTax uses a 128 bit SSL encryption for transmission of data and
        enables complete data privacy. Also, ClearTax does not share its data
        with unaffiliated third parties.
      </p>
    ),
  },
  {
    header: 'What are the GST services offered by ClearTax?',
    content: (
      <p>
        ClearTax provides ClearTax GST filing software for accurate GST filing,
        reconciliation and claiming ITC. ClearTax GST facilitates the generation
        of e-invoices and e-way bill.
      </p>
    ),
  },
  {
    header: 'How to e-verify my ITR?',
    content: (
      <p>
        You can e-verify your ITR within 120 days from the date of filing. You
        can e-verify using your net banking account or{' '}
        <a href="https://cleartax.in/s/aadhaar-card">Aadhaar</a> based OTP. A
        failure to e-verify your ITR can invalidate your ITR filing.
      </p>
    ),
  },
  {
    header: 'How to choose a suitable mutual fund for SIP?',
    content: (
      <p>
        You should not select a{' '}
        <a href="https://cleartax.in/mutual-funds">mutual fund</a> for{' '}
        <a href="https://cleartax.in/s/sip">SIP</a> only by considering the past
        performance of the fund and fund manager. To choose a suitable mutual
        fund, you also need to check if the fund&apos;s investment objective is
        in line with your goals. You can also use our{' '}
        <a href="https://cleartax.in/s/sip-calculator">SIP calculator</a> to
        estimate the return on your mutual fund investments.
      </p>
    ),
  },
  {
    header: 'How does ClearOne invoicing software help small businesses?',
    content: (
      <p>
        You can create professional invoices and other business documents easily
        on mobile app or computer with ClearOne{' '}
        <a href="https://cleartax.in/s/invoicing-software">
          invoicing software
        </a>
        . SMEs can also send invoices and payment reminders to customers through
        WhatsApp and Email with a click of a button.
      </p>
    ),
  },
];
